<template>
  <van-dialog
    v-model:show="showModel"
    :show-confirm-button="false"
    :show-cancel-button="false"
    class="aligned-dialog"
  >
    <template #title>
      <div class="dialog-title">
        <span>{{ title }}</span>
      </div>
    </template>
    <div v-if="message" class="px-4 pt-2 pb-3 text-center text-[#646566]">{{ message }}</div>
    <slot v-else />
    <div v-if="showFooter" class="flex justify-between px-4 pt-2 pb-4">
      <van-button
        v-if="showCancel"
        size="small"
        color="#E3E3E3"
        style="color: #333"
        @click="onCancel"
        >Cancel</van-button
      >
      <div class="flex gap-2">
        <van-button
          v-if="confirm1Text"
          class="return-target-btn"
          size="small"
          color="#333"
          @click="onConfirm1"
          >{{ confirm1Text }}</van-button
        >
        <van-button
          v-if="confirm2Text"
          class="return-target-btn"
          size="small"
          color="#333"
          @click="onConfirm2"
          >{{ confirm2Text }}</van-button
        >
      </div>
    </div>
  </van-dialog>
</template>

<script setup lang="ts">
const showModel = defineModel<boolean>('show')

const props = defineProps({
  title: { type: String, default: 'Operation Confirm' },
  message: { type: String, default: 'Please double confirm your operation?' },
  confirm1Text: { type: String, default: 'Confirm' },
  confirm2Text: { type: String, default: '' },
  closeOnConfirm: { type: Boolean, default: true },
  showFooter: { type: Boolean, default: true },
  showCancel: { type: Boolean, default: true },
})

const emit = defineEmits<{
  (e: 'cancel'): void
  (e: 'confirm1'): void
  (e: 'confirm2'): void
}>()

const title = computed(() => props.title)
const message = computed(() => props.message)
const confirm1Text = computed(() => props.confirm1Text)
const confirm2Text = computed(() => props.confirm2Text)
const closeOnConfirm = computed(() => props.closeOnConfirm)
const showFooter = computed(() => props.showFooter)
const showCancel = computed(() => props.showCancel)

const onCancel = () => {
  showModel.value = false
  emit('cancel')
}
const onConfirm1 = () => {
  emit('confirm1')
  if (closeOnConfirm.value) showModel.value = false
}
const onConfirm2 = () => {
  emit('confirm2')
  if (closeOnConfirm.value) showModel.value = false
}
</script>

<style scoped>
.return-target-btn {
  min-width: 60px;
}
</style>
